var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-box"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.brandName))]),_c('div',{staticClass:"action-box"},_vm._l((_vm.actionList),function(item,index){return _c('div',{key:index,staticClass:"action-item",on:{"click":function($event){return _vm.goAction(item.path)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }